export default "__VITE_ASSET__0ea63192__"